// @ts-nocheck
import { Button } from "@/components/Button"
import { Table } from "@/components/Table"
import { useRainCorporateFormContext } from "@usher/pe-client-front-end-lib"
import { useMemo } from "react"
import { FormProvider } from "react-hook-form"
import { FileUploader } from "./FileUploader"
import { useRainApi } from "./useApi"

const Documents = () => {
  const { verification, checkVerifications } = useRainCorporateFormContext()
  const { onSubmit, loading, control, handleSubmit, formModel, reset } = useRainApi("documents", console.log)
  const documentRows = useMemo(
    () => [
      { type: "Business Registration", file: <FileUploader type="21" verification={verification} onSuccess={checkVerifications} /> },
      { type: "Memorandum of Association", file: <FileUploader type="18" verification={verification} onSuccess={checkVerifications} /> },
      { type: "Company Constitution", file: <FileUploader type="18" verification={verification} onSuccess={checkVerifications} /> },
      { type: "Proof of Address", file: <FileUploader type="22" verification={verification} onSuccess={checkVerifications} /> },
      { type: "Shareholder Registry", file: <FileUploader type="19" verification={verification} onSuccess={checkVerifications} /> },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [verification],
  )
  return (
    <div className="">
      <h1 className="text-2xl text-black mb-4">Upload Supporting Documents</h1>
      <FormProvider {...{ ...formModel, control, handleSubmit, reset }}>
        <form noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
          <Table
            data={documentRows}
            heads={[
              {
                key: "type",
                label: "Document Type",
                className: "font-bold py-2",
              },
              {
                key: "file",
                label: "File",
                className: "font-bold py-2",
              },
            ]}
          />
          <Button className="w-ful mt-4" loading={loading} to="/company-verification/form/add-ubo">
            Continue
          </Button>
        </form>
      </FormProvider>
    </div>
  )
}

export default Documents
